import BrandText from "../../assets/BrandText";
import CustomLink from "../../components/Link";

export default function NotFound() {
  return (
    <div className="d-flex flex-row-fluid flex-column justify-content-center align-items-center text-center pb-40">
      <div className="error-text pointer-events-none">404</div>
      <div className="d-flex flex-center mb-5">
        <CustomLink to="/">
          <BrandText className="logo-default h-40px max-h-40px" />
        </CustomLink>
      </div>
      <h1 className="display-1 font-weight-bold">OOPS!</h1>
      <span className="display-4 font-weight-boldest mb-8">
        Something went wrong here
      </span>
    </div>
  );
}
